import React from "react";
import "./ContactsHeader.css";

const ContactsHeader = () => {
  return (
    <section className="ContactsHeader-container">
      <div className="ContactsHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="ContactsHeader-title">Contact Us</h1>
          <div className="ContactsHeader-breadcrumb">
            <button className="btn btn-primary">Home - Contact Us</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactsHeader;
